<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="500px"
    persistent
    @click:outside="close"
  >
    <v-card class="gumroad-modal">
      <div class="modal-header">
        <h3 class="modal-title">Premium Content Verification</h3>
      </div>
      
      <v-card-text class="pt-6">
        <p class="mb-4">
          The <strong>{{ productName }}</strong> design is premium content. 
          Please verify your purchase to access the editor.
        </p>

        <v-alert
          v-if="errorMessage"
          type="error"
          dense
          outlined
          class="mb-4"
        >
          {{ errorMessage }}
        </v-alert>

        <v-text-field
          v-model="licenseKey"
          label="Gumroad License Key"
          placeholder="Enter your license key"
          outlined
          dense
          hide-details="auto"
          :disabled="loading"
          @keyup.enter="verifyConfig"
        ></v-text-field>
        
        <div class="mt-2 caption text-center grey--text">
          Don't have a key? 
          <a :href="gumroadUrl" target="_blank" class="brand-link">Buy on Gumroad</a>
        </div>
      </v-card-text>

      <v-card-actions class="pb-5 px-6 justify-end">
        <v-btn
          text
          @click="close"
          :disabled="loading"
          class="grey--text text--darken-1"
        >
          Cancel
        </v-btn>
        <v-btn
          color="#1a1a40"
          dark
          @click="verifyConfig"
          :loading="loading"
          elevation="0"
          class="px-6"
        >
          Verify
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GumroadLicenseModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    productName: {
      type: String,
      default: "Fighter Design",
    },
    productPermalink: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      licenseKey: "",
      loading: false,
      errorMessage: "",
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.close();
        }
      },
    },
    gumroadUrl() {
        return `https://gumroad.com/l/${this.productPermalink}`;
    }
  },
  methods: {
    close() {
      this.errorMessage = "";
      this.licenseKey = "";
      this.$emit("close");
    },
    async verifyConfig() {
      if (!this.licenseKey.trim()) {
        this.errorMessage = "Please enter a license key.";
        return;
      }

      this.loading = true;
      this.errorMessage = "";
      this.$emit("verify-attempt"); // Notify parent of attempt

      try {
        console.log("Verifying license for product:", this.productPermalink);
        const response = await fetch("https://api.gumroad.com/v2/licenses/verify", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            product_permalink: this.productPermalink,
            product_id: this.productId, // Added product_id
            license_key: this.licenseKey.trim(),
          }),
        });

        const data = await response.json();
        console.log("Gumroad API Response:", data);

        if (data.success) {
            const purchase = data.purchase || {};
            if (purchase.refunded) {
                this.errorMessage = "This purchase has been refunded.";
            } else if (purchase.chargebacked) {
                 this.errorMessage = "This purchase has been chargebacked.";
            } else {
                 this.$emit("verified", {
                    key: this.licenseKey.trim(),
                    permalink: this.productPermalink
                 });
                 this.close();
            }
        } else {
          // Use message from Gumroad if available, otherwise default
          this.errorMessage = data.message || "Invalid license key. Please check and try again.";
        }
      } catch (error) {
        console.error("Verification error:", error);
        this.errorMessage = "Network error or blocked by browser. Please check your internet connection.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.gumroad-modal {
  font-family: 'Lato', sans-serif;
  border-top: 4px solid #c5a059;
}

.modal-header {
  background-color: #f5f5f5;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.modal-title {
  color: #1a1a40;
  font-family: 'Playfair Display', serif;
  margin: 0;
  font-size: 1.25rem;
}

.brand-link {
  color: #c5a059;
  font-weight: bold;
  text-decoration: none;
}

.brand-link:hover {
  text-decoration: underline;
}
</style>
